import React, { useContext } from "react";
import { styled } from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import DoneIcon from "@mui/icons-material/Done";
import { ActionButton } from "fe-common/ui/buttons/actionButton";
import { ClinicModeContext } from "../../../../context/diagnosticAgent";
import { useSaveCase } from "../../saveCase/useSaveCase";
//region [[ Styles ]]

const SaveCaseButtonView = styled(ActionButton)({});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SaveCaseButtonProps {
  className?: string;
  onlyIcon?: boolean;
}

//endregion [[ Props ]]

//region [[ Text ]]
export const CASE_SAVED = "Case Saved";
export const SAVE_CASE = "Save Case";
//endregion [[ Text ]]

export const SaveCaseButton = ({
  onlyIcon,
  className,
}: SaveCaseButtonProps) => {
  const clinicMode = useContext(ClinicModeContext);

  const { saveCase, displaySuccess, loading } = useSaveCase();

  if (clinicMode) return null;

  return (
    <SaveCaseButtonView
      className={className}
      onClick={saveCase}
      disabled={loading}
      icon={displaySuccess ? <DoneIcon /> : <BookmarkIcon />}
      label={displaySuccess ? CASE_SAVED : SAVE_CASE}
      iconOnly={onlyIcon}
    />
  );
};
